import { render, staticRenderFns } from "./ReturnToSupplier.vue?vue&type=template&id=855bd1f4&"
import script from "./ReturnToSupplier.vue?vue&type=script&lang=js&"
export * from "./ReturnToSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports